/**
 * Created by Administrator on 2018/3/21.
 */
import LeftNav from '../components/LeftNav/index'//顶部导航栏
import HeaderCommon from '../components/HeaderCommon/index'//顶部导航栏


export default {
  install(Vue) {

    Vue.component(LeftNav.name, LeftNav)
    Vue.component(HeaderCommon.name, HeaderCommon)

  }
}



// WEBPACK FOOTER //
// ./src/router/plugins.js